import { AuthContext } from '@repo-level/core-front';
import chestSrc from 'assets/images/mission/chest-1.webp';
import { ImageComponent } from 'components/Image';
import { useMissions } from 'modules/mission/hooks/useMissions';
import type { FC } from 'react';
import { memo, useContext } from 'react';
import { useNavigation } from 'react-navi';
import { ScMissionPanel } from './styled';

export interface IMissionPanelProps {
  onLinkClick?: () => void;
}

export const MissionPanel: FC<IMissionPanelProps> = memo(({ onLinkClick }) => {
  const { isAuthenticated } = useContext(AuthContext);

  const { navigate } = useNavigation();

  const { currentMission } = useMissions();

  if (!currentMission) return null;

  return (
    <ScMissionPanel
      onClick={() => {
        onLinkClick && onLinkClick();
        navigate('/mission');
      }}
    >
      <div className="inner">
        <p className="title">Love Strike Quest</p>
        <ImageComponent
          alt="mission img"
          height={55}
          src={isAuthenticated ? currentMission.imgSrc : chestSrc}
          width={55}
        />
      </div>
    </ScMissionPanel>
  );
});
